__webpack_require__.p = "https://riise-admin.vercel.app/";